import { render, staticRenderFns } from "./DragDropClone.vue?vue&type=template&id=48091fb8"
import script from "./DragDropClone.vue?vue&type=script&lang=js"
export * from "./DragDropClone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports